import { AnimationFunction } from '../../../helpers/animation/animation-function';
import { linearTween } from '../../../helpers/animation/linear-tween';
import { scrollTo } from '../scroll-to';

export function scrollToOffset(
	distance: number,
	animationFunction: AnimationFunction = linearTween,
	duration = 300,
	offset = 0,
	wrapper: HTMLElement | Window = window
) {
	scrollTo(distance + offset, animationFunction, duration, wrapper);
}
